import lodashIsEqual from "lodash/isEqual";
import { replace } from "react-router-redux";
import { getMetricsFromSchema } from "reducers/selectors/collection";
import { dimensionsPanelToQueryParams } from "reducers/dimensions-panel/helpers";
import { setDraft } from "actions/tool-panel/draft/actions";
import { SET_APPLIED } from "actions/tool-panel/applied/constants";
import { DOOR_GROUP_QUERY_KEY } from "helpers/door-collection";

// When applying dimension panels state, sync it with "draft" for Doors panel
export const syncDraftWithApplied = (action$) =>
    action$.ofType(SET_APPLIED).concatMap(({ payload }) => {
        return [setDraft(payload)];
    });

// When applying dimension panels state, sync it with "draft" for Doors panel
export const syncAppliedWithUrl = (action$, store$) =>
    action$.ofType(SET_APPLIED).concatMap(() => {
        const state = store$.getState();
        const { routing, collection, dimensionsPanel } = state;
        const query = {
            ...routing.locationBeforeTransitions.query,
        };
        const metricsFromSchema = getMetricsFromSchema(state, collection.collectionId);

        const dimensionsQuery = dimensionsPanelToQueryParams(dimensionsPanel.applied, {
            legacyMetrics: metricsFromSchema.length === 0,
        });
        query[DOOR_GROUP_QUERY_KEY] = dimensionsQuery ? JSON.stringify(dimensionsQuery) : undefined;

        // When no URL changes is needed, bail
        if (lodashIsEqual(routing.locationBeforeTransitions.query, query)) {
            return [];
        }

        return [
            replace({
                pathname: routing.locationBeforeTransitions.pathname,
                query,
            }),
        ];
    });
